import { createSlice } from '@reduxjs/toolkit';

import moment from 'moment';
import { INITIAL_DOWNLOADS_FILTERS } from '../../components/Downloads/DownloadsFilters';
import { INITIAL_HISTORY_FILTERS } from '../../components/History/HistoryFilters';
import { Constants } from '../../const';

const startOfMonth = moment()
  .startOf('month')
  .format(Constants.CommonConst.GLOBAL_DATE_FORMAT);
const today = moment().format(Constants.CommonConst.GLOBAL_DATE_FORMAT);
const { SEARCH_TYPES, SCREEN_TYPES } = Constants.CommonConst;

const initialState = {
  isOngoingMonitoringTableView: true,
  isInitialScreeningTableView: true,
  initialScreeningModule: 'name_screen',
  common_initialScreeningModule: 'name_screen',
  ongoingMonitoringModule: 'name_screen',
  common_ongoingMonitoringModule: 'name_screen',
  assign_screeningModule: 'name_screening',
  initialMyqueue: {
    channel: '',
    product: '',
    transaction_type: '',
    searchId: '',
    searchType: [],
    alertListType: [],
    alerted: '',
    targetStartDate: '',
    targetEndDate: '',
    initiatedStartDate: '',
    initiatedEndDate: '',
    status: '',
    alert: 20,
    bookmark: null,
    team: '',
    manager: '',
    analyst: '',
    horizontalTeam: '',
    risk_type: [],
    country: '',
    industry: '',
    occupation: '',
    onboarding_type: '',
    transaction_product_type: '',
    party: '',
  },
  initialCommonQueue: {
    channel: '',
    product: '',
    transaction_type: '',
    searchId: '',
    searchType: [],
    alertListType: [],
    alerted: '',
    targetStartDate: '',
    targetEndDate: '',
    initiatedStartDate: '',
    initiatedEndDate: '',
    status: '',
    alert: 20,
    bookmark: null,
    team: '',
    manager: '',
    analyst: '',
    horizontalTeam: '',
    risk_type: [],
    country: '',
    industry: '',
    occupation: '',
    onboarding_type: '',
    transaction_product_type: '',
    party: '',
    assignedStatus: '',
  },
  ongoingMyqueue: {
    channel: '',
    product: '',
    transaction_type: '',
    searchId: '',
    searchType: [],
    alertListType: [],
    alerted: '',
    targetStartDate: '',
    targetEndDate: '',
    initiatedStartDate: '',
    initiatedEndDate: '',
    status: '',
    alert: 20,
    bookmark: null,
    team: '',
    manager: '',
    analyst: '',
    horizontalTeam: '',
    risk_type: [],
    country: '',
    industry: '',
    occupation: '',
    onboarding_type: '',
    transaction_product_type: '',
    party: '',
  },
  ongoingCommonQueue: {
    channel: '',
    product: '',
    transaction_type: '',
    searchId: '',
    searchType: [],
    alertListType: [],
    alerted: '',
    targetStartDate: '',
    targetEndDate: '',
    initiatedStartDate: '',
    initiatedEndDate: '',
    status: '',
    alert: 20,
    bookmark: null,
    team: '',
    manager: '',
    analyst: '',
    horizontalTeam: '',
    risk_type: [],
    country: '',
    industry: '',
    occupation: '',
    onboarding_type: '',
    transaction_product_type: '',
    party: '',
    assignedStatus: '',
  },

  initialPageSizeInitialScreening: 10,
  initialPageIndexInitialScreening: 0,
  initialPageSizeOngoingMonitoring: 10,
  initialPageIndexOngoingMonitoring: 0,

  downloadReportFilters: { ...INITIAL_DOWNLOADS_FILTERS },
  historyFilters: { ...INITIAL_HISTORY_FILTERS },
  downloadStatusFilters: {
    screening_type: SCREEN_TYPES.i.key,
    dates: { start_date: startOfMonth, end_date: today },
    search_type: SEARCH_TYPES.i.key,
    team: '',
    due_date: today,
    current_status: '',
    pending_with: '',
    final_verdict: '',
    manager_id: '',
  },
  riskRatingDashboardFilters: {
    screen_type: SCREEN_TYPES.o.key,
    search_type: '',
    start_date: '',
    end_date: '',
    duration: '',
    analyst: '',
    manager: '',
    team: '',
  },
  exclusionListFilter: {
    filter_type: '',
    batchID: '',
    search_type: '',
    listType: [],
  },
  addtoExclusionFilter: {
    filterType: '',
    Start_Date: '',
    search_type: '',
    End_Date: '',
    listType: [],
  },
  dashboardFilters: {
    manager_id: '',
    team: '',
    StartDate: '',
    EndDate: '',
    analyst: '',
    screen_type: 'OngoingScreening',
    seach_initiated: '',
  },
  userData: {},
  suppressions: {},
  defaultRatings: [],
  isRiskRatingConfigured: false,
  hasUnsavedRiskRatingFile: false,
  unsavedRiskRatingFiles: {},
  hasUnsavedRiskRatingConfiguration: false,
  assignSingleColumn: [],
  assignTransactionSingleColumn: [],
  assignBulkColumn: [],
};
export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    ongoingMonitoringTableView: (state) => {
      state.isOngoingMonitoringTableView = !state.isOngoingMonitoringTableView;
    },
    initialScreeningTableView: (state) => {
      state.isInitialScreeningTableView = !state.isInitialScreeningTableView;
    },
    setInitialScreeningModule: (state, action) => {
      state.initialScreeningModule = action.payload
        ? action.payload
        : state.initialScreeningModule;
    },
    setOngoingMonitoringModule: (state, action) => {
      state.ongoingMonitoringModule = action.payload
        ? action.payload
        : state.ongoingMonitoringModule;
    },
    setCommonInitialScreeningModule: (state, action) => {
      state.common_initialScreeningModule = action.payload
        ? action.payload
        : state.common_initialScreeningModule;
    },
    setCommonOngoingMonitoringModule: (state, action) => {
      state.common_ongoingMonitoringModule = action.payload
        ? action.payload
        : state.common_ongoingMonitoringModule;
    },
    setAssignScreeningModule: (state, action) => {
      state.assign_screeningModule = action.payload
        ? action.payload
        : state.assign_screeningModule;
    },
    setInitialPageSizeInitialScreening: (state, action) => {
      state.initialPageSizeInitialScreening = action.payload
        ? action.payload
        : state.initialPageSizeInitialScreening;
    },
    setInitialPageIndexInitialScreening: (state, action) => {
      state.initialPageIndexInitialScreening = action.payload
        ? action.payload
        : state.initialPageIndexInitialScreening;
    },
    resetInitialPageIndexInitialScreening: (state) => {
      state.initialPageIndexInitialScreening = 0;
    },
    resetInitialPageSizeInitialScreening: (state) => {
      state.initialPageIndexInitialScreening = 10;
    },
    setInitialPageSizeOngoingMonitoring: (state, action) => {
      state.initialPageSizeOngoingMonitoring = action.payload
        ? action.payload
        : state.initialPageSizeOngoingMonitoring;
    },
    setInitialPageIndexOngoingMonitoring: (state, action) => {
      state.initialPageIndexOngoingMonitoring = action.payload
        ? action.payload
        : state.initialPageIndexOngoingMonitoring;
    },
    resetInitialPageIndexOngoingMonitoring: (state) => {
      state.initialPageIndexOngoingMonitoring = 0;
    },
    resetInitialPageSizeOngoingMonitoring: (state) => {
      state.initialPageSizeOngoingMonitoring = 10;
    },
    setDownloadReportFilters: (state, action) => {
      state.downloadReportFilters = action?.payload
        ? action.payload
        : INITIAL_DOWNLOADS_FILTERS;
    },
    setHistoryFilters: (state, action) => {
      state.historyFilters = action.payload
        ? action.payload
        : INITIAL_HISTORY_FILTERS;
    },
    setInitialMyqueue: (state, action) => {
      state.initialMyqueue = action.payload
        ? action.payload
        : initialState.initialMyqueue;
    },
    setInitialCommon: (state, action) => {
      state.initialCommonQueue = action.payload
        ? action.payload
        : initialState.initialCommonQueue;
    },
    setOngoingMyqueue: (state, action) => {
      state.ongoingMyqueue = action.payload
        ? action.payload
        : initialState.ongoingMyqueue;
    },
    setOngoingCommon: (state, action) => {
      state.ongoingCommonQueue = action.payload
        ? action.payload
        : initialState.ongoingCommonQueue;
    },
    setDownloadStatusFilters: (state, action) => {
      state.downloadStatusFilters = action.payload
        ? action.payload
        : initialState.downloadStatusFilters;
    },
    setRiskRatingDashboardFilters: (state, action) => {
      state.riskRatingDashboardFilters = action.payload
        ? action.payload
        : initialState.riskRatingDashboardFilters;
    },
    setExclusionListFilter: (state, action) => {
      state.exclusionListFilter = action.payload
        ? action.payload
        : initialState.exclusionListFilter;
    },
    setAddToExclusionListFilter: (state, action) => {
      state.addtoExclusionFilter = action.payload
        ? action.payload
        : initialState.addtoExclusionFilter;
    },
    setDashboardFilters: (state, action) => {
      state.dashboardFilters = action.payload
        ? action.payload
        : initialState.dashboardFilters;
    },

    setUserData: (state, action) => {
      state.userData = action.payload ? action.payload : initialState.userData;
    },
    setSuppressions: (state, action) => {
      state.suppressions = action.payload
        ? action.payload
        : initialState.suppressions;
    },
    setDefaultRatings: (state, action) => {
      state.defaultRatings = action.payload
        ? action.payload
        : initialState.defaultRatings;
    },
    setIsRiskRatingConfigured: (state, action) => {
      state.isRiskRatingConfigured = action.payload
        ? action.payload
        : initialState.isRiskRatingConfigured;
    },
    setHasUnsavedRiskRatingFile: (state, action) => {
      state.hasUnsavedRiskRatingFile = action.payload
        ? action.payload
        : initialState.hasUnsavedRiskRatingFile;
    },
    setUnsavedRiskRatingFile: (state, action) => {
      const { key, hasUnsaved } = action.payload;
      if (hasUnsaved) {
        state.unsavedRiskRatingFiles[key] = true;
      } else {
        delete state.unsavedRiskRatingFiles[key];
      }
      state.hasUnsavedRiskRatingFile =
        Object.keys(state.unsavedRiskRatingFiles).length > 0;
    },
    clearAllUnsavedRiskRatingFiles: (state) => {
      state.unsavedRiskRatingFiles = {};
      state.hasUnsavedRiskRatingFile = false;
    },
    setHasUnsavedRiskRatingConfiguration: (state, action) => {
      state.hasUnsavedRiskRatingConfiguration = action.payload ?? false;
    },
    resetCommonState: () => initialState,
    setAssignSingleColumn: (state, action) => {
      state.assignSingleColumn = action.payload
        ? action.payload
        : initialState.assignSingleColumn;
    },
    setAssignTransactionSingleColumn: (state, action) => {
      state.assignTransactionSingleColumn = action.payload
        ? action.payload
        : initialState.assignTransactionSingleColumn;
    },
    setAssignBulkColumn: (state, action) => {
      state.assignBulkColumn = action.payload
        ? action.payload
        : initialState.assignBulkColumn;
    },
  },
});
export const {
  ongoingMonitoringTableView,
  initialScreeningTableView,
  setInitialScreeningModule,
  setOngoingMonitoringModule,
  setCommonOngoingMonitoringModule,
  setCommonInitialScreeningModule,
  setInitialPageIndexInitialScreening,
  setInitialPageSizeInitialScreening,
  resetInitialPageSizeInitialScreening,
  resetInitialPageIndexInitialScreening,
  setInitialPageIndexOngoingMonitoring,
  setInitialPageSizeOngoingMonitoring,
  resetInitialPageSizeOngoingMonitoring,
  resetInitialPageIndexOngoingMonitoring,
  setDownloadReportFilters,
  setHistoryFilters,
  setDownloadStatusFilters,
  setRiskRatingDashboardFilters,
  setExclusionListFilter,
  setAddToExclusionListFilter,
  setDashboardFilters,
  setUserData,
  setSuppressions,
  setInitialMyqueue,
  setInitialCommon,
  setOngoingCommon,
  setOngoingMyqueue,
  setIsRiskRatingConfigured,
  setHasUnsavedRiskRatingFile,
  setUnsavedRiskRatingFile,
  clearAllUnsavedRiskRatingFiles,
  setHasUnsavedRiskRatingConfiguration,
  setDefaultRatings,
  resetCommonState,
  setAssignScreeningModule,
  setAssignSingleColumn,
  setAssignBulkColumn,
  setAssignTransactionSingleColumn,
} = commonSlice.actions;
export default commonSlice.reducer;
